import PropTypes from 'prop-types';
import { Component } from 'react';
import withTrackPageView from 'automation-ui-usage-tracking/TrackPageViewDecorator';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
class TrackPageView extends Component {
  componentDidMount() {
    const {
      extraJSON,
      screen,
      subscreen,
      trackPageView
    } = this.props;
    const screenTrackingOverrides = {};
    if (screen) {
      screenTrackingOverrides.screen = screen;
    }
    if (subscreen) {
      screenTrackingOverrides.subscreen = subscreen;
    }
    trackPageView(screenTrackingOverrides, extraJSON);
  }
  render() {
    // This component intentionally renders nothing. It is used as a
    // convenience component to use screen and subscreen tracking
    // context to record a pageView event on mount.
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
}
TrackPageView.propTypes = {
  extraJSON: PropTypes.object,
  screen: PropTypes.string,
  subscreen: PropTypes.string,
  // mapped with withTrackPageView
  trackPageView: PropTypes.func.isRequired
};
TrackPageView.defaultProps = {
  extraJSON: {}
};
export default withTrackPageView(TrackPageView);